import { FormProvider, useForm } from "react-hook-form";

import { ProgressCircle } from "@smart/itops-sb-design-system-dom";
import { useLoadSetting, useLoadTeam } from "@smart/manage-gql-client-dom";

import { BrandingPreview } from "./branding-preview";
import { BrandingSettings } from "./branding-settings";
import { Branding, BrandingInput, getDefaultValues } from "./types";

type BrandingWebViewContentProps = {
  currentBranding?: Branding;
  team:
    | {
        uri: string;
        name: string;
        picture?: string | null;
      }
    | undefined;
  firmLogoDataUrl?: string | null;
};

export const BrandingWebViewContent = ({
  currentBranding,
  team,
  firmLogoDataUrl,
}: BrandingWebViewContentProps) => {
  const form = useForm<BrandingInput>({
    defaultValues: getDefaultValues(currentBranding),
  });

  return (
    <FormProvider {...form}>
      <div className="flex h-full min-h-0 overflow-hidden">
        <div className="w-[38.3rem] h-full min-h-0 overflow-y-auto">
          <BrandingSettings />
        </div>
        <div className="flex-1 min-h-0">
          <BrandingPreview team={team} firmLogoDataUrl={firmLogoDataUrl} />
        </div>
      </div>
    </FormProvider>
  );
};

export const BrandingWebView = () => {
  const { result: settings, loading } = useLoadSetting({});
  const { result: team, loading: teamLoading } = useLoadTeam({});

  if (loading || teamLoading) return <ProgressCircle />;

  return (
    <BrandingWebViewContent
      currentBranding={settings?.branding}
      team={team?.values}
      firmLogoDataUrl={settings?.firmLogoDataUrl}
    />
  );
};
